import type { Module } from 'vuex';
import { TranslateLanguagePageItem } from '@/types/TranslateLanguagePageItem';
import {RootState} from "@/store";

export interface TranslateLanguagePageItemsState {
  translateLanguagePageItems: TranslateLanguagePageItem[];
}

const translateLanguagePageItemsModule: Module<TranslateLanguagePageItemsState, RootState> = {
  namespaced: true,

  state: (): TranslateLanguagePageItemsState => ({
    translateLanguagePageItems: [],
  }),

  getters: {
    getById: (state) => (idTranslateLanguagePageItem: number): TranslateLanguagePageItem | undefined => {
      return state.translateLanguagePageItems.find(translateLanguagePageItem => translateLanguagePageItem.idTranslateLanguagePageItem === idTranslateLanguagePageItem);
    },
    getByLanguagePageItem: (state) => (idLanguagePageItem: number): TranslateLanguagePageItem[] => {
      return state.translateLanguagePageItems.filter(translateLanguagePageItem => translateLanguagePageItem.idLanguagePageItem === idLanguagePageItem);
    },
  },

  mutations: {
    setTranslateLanguagePageItems(
      state,
      payload: { translateLanguagePageItems: Record<number, any> }
    ) {
      state.translateLanguagePageItems = Object
        .values(payload.translateLanguagePageItems)
        .map(raw => TranslateLanguagePageItem.fromRaw(raw));
    },

    setTranslateLanguagePageItemCreate(
      state,
      payload: {
        idTranslateLanguagePageItem: number;
        idLanguagePageItem: number;
        idLanguage: number;
        text: string;
      }
    ) {
      const raw = {
        idTranslateLanguagePageItem: payload.idTranslateLanguagePageItem,
        idLanguagePageItem: payload.idLanguagePageItem,
        idLanguage: payload.idLanguage,
        text: payload.text,
        locked: false,
      };
      state.translateLanguagePageItems.push(TranslateLanguagePageItem.fromRaw(raw));
    },

    setTranslateLanguagePageItemUpdate(
      state,
      payload: {
        idTranslateLanguagePageItem: number;
        text?: string;
      }
    ) {
      const translateLanguagePageItem = state.translateLanguagePageItems.find(translateLanguagePageItem => translateLanguagePageItem.idTranslateLanguagePageItem === payload.idTranslateLanguagePageItem);
      if (!translateLanguagePageItem) return;
      if (payload.text !== undefined) translateLanguagePageItem.text = payload.text;
    },

    setTranslateLanguagePageItemDelete(
      state,
      payload: { idTranslateLanguagePageItem: number }
    ) {
      state.translateLanguagePageItems = state.translateLanguagePageItems.filter(
        translateLanguagePageItem => translateLanguagePageItem.idTranslateLanguagePageItem !== payload.idTranslateLanguagePageItem
      );
    },

    setTranslateLanguagePageItemLock(
      state,
      payload: { idTranslateLanguagePageItem: number }
    ) {
      const translateLanguagePageItem = state.translateLanguagePageItems.find(translateLanguagePageItem => translateLanguagePageItem.idTranslateLanguagePageItem === payload.idTranslateLanguagePageItem);
      if (translateLanguagePageItem) translateLanguagePageItem.locked = true;
    },

    setTranslateLanguagePageItemUnlock(
      state,
      payload: { idTranslateLanguagePageItem: number }
    ) {
      const translateLanguagePageItem = state.translateLanguagePageItems.find(translateLanguagePageItem => translateLanguagePageItem.idTranslateLanguagePageItem === payload.idTranslateLanguagePageItem);
      if (translateLanguagePageItem) translateLanguagePageItem.locked = false;
    },
  },

  actions: {
    wsSetTranslateLanguagePageItems({ commit }, payload) {
      commit('setTranslateLanguagePageItems', payload);
    },
    wsTranslateLanguagePageItemCreate({ commit }, payload) {
      commit('setTranslateLanguagePageItemCreate', payload);
    },
    wsTranslateLanguagePageItemUpdate({ commit }, payload) {
      commit('setTranslateLanguagePageItemUpdate', payload);
    },
    wsTranslateLanguagePageItemDelete({ commit }, payload) {
      commit('setTranslateLanguagePageItemDelete', payload);
    },
    wsTranslateLanguagePageItemLock({ commit }, payload) {
      commit('setTranslateLanguagePageItemLock', payload);
    },
    wsTranslateLanguagePageItemUnlock({ commit }, payload) {
      commit('setTranslateLanguagePageItemUnlock', payload);
    },
  },
};

export default translateLanguagePageItemsModule;
